import { useQuery } from "@tanstack/react-query";
import { getDealLogs } from "@/api";
import { DealLog, CompanyLog, HotlistLog } from "@/types";

export const useDealLogs = (dealId?: string) => {
  const query = useQuery<{ dealLogs: DealLog[]; companyLogs: CompanyLog[]; hotlistLogs: HotlistLog[] }>({
    queryKey: ["dealLogs", dealId],
    queryFn: () => getDealLogs(dealId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!dealId,
  });

  return {
    ...query,
    data: query.data || { dealLogs: [], companyLogs: [], hotlistLogs: [] },
  }
};
